(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('orderStatus', OrderStatus)

    /** @ngInject */
    function OrderStatus(PATHS) {
        function OrderStatusController() {
            const vm = this;
        }

        return {
            bindToController: true,
            controller: OrderStatusController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/order-status/order-status.html`,
            scope: {
                unit: '=',
                orderId: '=',
                canUserEdit: '='
            }
        }
    }
}());